module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "blocco h100 w100"
  }, [_c('h1', [_vm._v("A quale Hotel vuoi accedere?")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_vm._l((_vm.hotels), function(hotel) {
    return _c('div', [(hotel.beachtype === 'grid') ? _c('router-link', {
      staticClass: "btn btn-green block left",
      attrs: {
        "to": {
          path: '/ombrelli/' + hotel._id
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-th"
    }), _vm._v(" " + _vm._s(hotel.name))]) : _vm._e(), _vm._v(" "), (hotel.beachtype === 'canvas') ? _c('router-link', {
      staticClass: "btn btn-green block left",
      attrs: {
        "to": {
          path: '/Canvas/' + hotel._id
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-umbrella-beach"
    }), _vm._v(" " + _vm._s(hotel.name))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-blue block left",
    attrs: {
      "to": {
        path: '/addhotel'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" aggiungi Hotel")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7cbfb06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hotel.vue
// module id = 666
// module chunks = 1